<template>
  <v-card class="application-chat mt-3">
    <v-card-title>
      <v-avatar size="50" class="mr-3" v-if="application.opportunity.logo">
        <img :src="application.opportunity.logo" />
      </v-avatar>
      <div>
        <div>{{ application.opportunity.name }}</div>
        <div class="subheading" :class="themes.candidate.light.cardSubtitle">
          {{ application.opportunity.organization }}
        </div>
      </div>
    </v-card-title>

    <v-card-text>
      <Message
        v-for="chat in messages"
        :key="`chat-${chat.id}`"
        :chat="chat"
        flipped="Candidate"
      />
    </v-card-text>
    <v-card-actions v-if="applicationActive" class="px-0 py-0">
      <v-text-field box
        v-model="composing"
        :disabled="sending"
        placeholder="Type to respond"
        :append-icon="sending ? 'mdi-loading' : 'mdi-send'"
        @click:append="sendMessage"
        @keyup.enter.exact="sendMessage"
        color="primary"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import Message from '@/components/ChatMessage'

// Vue Component
export default {
  components: { Message },
  props: ['application', 'chats'],
  created() {
    this.$store.dispatch('candidate/chats/fetchApplication', this.application.id).then(() => {
      // Clear notifications after messages are marked as Read
      this.$store.dispatch('candidate/notifications/fetchAll')
    })
  },
  data() {
    return {
      composing: '',
      sending: false,
    }
  },
  computed: {
    messages() {
      var messages = this.chats
      return messages.sort(({ createdAt: a }, { createdAt: b }) => {
        if (new Date(a) > new Date(b)) return 1
        if (new Date(a) < new Date(b)) return -1
        return 0
      })
    },
    applicationActive() {
      return new Date(this.application.opportunity.commencesAt) > new Date()
    },
  },
  methods: {
    sendMessage() {
      var chat = { content: this.composing }
      this.sending = true
      this.$http.post(`candidate/applications/${this.application.id}/chats`, chat).then(response => {
        this.messages = response.data
        this.composing = ''
      }).finally(() => {
        this.sending = false
        this.$store.dispatch('candidate/chats/fetchApplication', this.application.id)
      })
    },
  }
}
</script>

<style>
.application-chat .v-input {
  font-size: 14px;
}
.application-chat .v-text-field .v-input__slot {
  margin-bottom: 0;
  border-radius: 0;
  min-height: 40px;
}
.application-chat .v-text-field .v-input__append-inner {
  margin-top: 8px;
}
.application-chat .v-text-field__details {
  display: none;
}
.application-chat .v-input input[type=text] {
  margin-top: 4px;
}

.application-chat i.mdi-loading {
  animation: rotation 2s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
